const Button = ({page, event, data}) => {
    return ( <button onClick={() => event(data)}>{page}</button> );
}
 
export default Button;